// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pt-ui-input{height:32px;line-height:32px;padding:2px 12px;border:1px solid #bcc2cc;border-radius:4px;color:#020a1a}.pt-ui-input:focus{outline:none;border-color:#45a321;border-color:var(--brand-primary)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
